// Layout constants are set as JavaScript constants to make it easy to share them between CSS and JavaScript

export const MEDIA_QUERY_MIN_SM = '600px';
export const MEDIA_QUERY_MAX_SM = '599px';
export const MEDIA_QUERY_MIN_MD = '900px';
export const MEDIA_QUERY_MAX_MD = '899px';
export const MEDIA_QUERY_MIN_LG = '1200px';
export const MEDIA_QUERY_MAX_LG = '1199px';

export const CONTAINER_MAX_WIDTH = '1376px';
export const TEXT_CONTENT_MAX_WIDTH = '75ch';
